import type { ContextSearchMatch } from "../utils/context-search-match"

type ContextSearchMatchPillProps = {
  match: ContextSearchMatch
}

export function ContextSearchMatchPill({ match }: ContextSearchMatchPillProps) {
  return (
    <span
      aria-label={`Matched ${match.label}: ${match.excerpt}`}
      className="border-primary/20 bg-primary/10 text-primary animate-in fade-in-0 zoom-in-95 inline-flex h-5 max-w-[9rem] shrink-0 items-center rounded-md border px-1.5 text-[10px] leading-none font-medium duration-150"
      title={`Matched ${match.label}: ${match.excerpt}`}
    >
      <span className="truncate">{match.label} match</span>
    </span>
  )
}
